import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { FilterLogisticsCenter } from "./FilterLogisticsCenter";
import { AddStorageModal } from "./AddLogisticsCenter";
import { useLogisticsCenter } from "./useLogisticsCenter";
import _ from "lodash";
import { useLazyGetLogisticsCenterListAllQuery } from "../../../../redux/api/organic/logisticsCenterApi";
import { EntLogisticsCenter } from "../../../../models/organic/logisticsCenter";
import { EntLogisticsCenterFilter } from "../../../../models/filters/organic/logisticsCenterFilter";
import { LogisticsCenterDetailsModal } from "./LogisticsCenterDetails";

enum FormField {
  centerName,
  regionId,
  areaId,
  territorialUnitId,
}

export const LogisticsCenter = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntLogisticsCenter>(new EntLogisticsCenter());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [viewItemId, setViewItemId] = useState<number|null>(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetLogisticsCenterListAllQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntLogisticsCenter, EntLogisticsCenterFilter>({
	initialFilter: new EntLogisticsCenterFilter(),
	query: getArchiveFolders
  });

  const {
	onAddStorage, onDeleteStorage, onEditStorage
  } = useLogisticsCenter(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntLogisticsCenter) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const openViewModal = (id: number) => {
	setViewItemId(id);
	setShowViewModal(true);
  };

  const setEntityFromFields = (): EntLogisticsCenterFilter => {
	let filt: EntLogisticsCenterFilter = _.clone(filter);

	filt.centerName = form.getFieldValue(FormField.centerName) ?? null;
	filt.regionId = form.getFieldValue(FormField.regionId) ?? null;
	filt.areaId = form.getFieldValue(FormField.areaId ?? null);
	filt.territorialUnitId = form.getFieldValue(FormField.territorialUnitId) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.centerName, value: null },
	  { name: FormField.regionId, value: null },
	  { name: FormField.areaId, value: null },
	  { name: FormField.territorialUnitId, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('Название центра') }</th>
		  <th>{ t('Регион') }</th>
		  <th>{ t('Район') }</th>
		  <th>{ t('Территориальная единица') }</th>
		  <th>{ t('Форма собственности') }</th>
		  <th>{ t('Статус реестра') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 9 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.centerName }</td>
			<td>{ i18n.language === 'ru' ? item.region?.nameRu : item.region?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.area?.nameRu : item.area?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.territorialUnit?.nameRu : item.territorialUnit?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.ownershipType?.nameRu : item.ownershipType?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.registerStatus?.nameRu : item.registerStatus?.nameKy }</td>
			<td>
			  <Flex gap="small" style={ { maxWidth: "120px" } }>
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteStorage(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
				<Tooltip title={ t('Посмотреть детали') }>
				  <Button
					className='btn_edit'
					onClick={ () => item.id !== null && openViewModal(item.id) }
					type="primary"
					shape="circle"
					icon={ <EyeOutlined/> }
				  >
					<i className="anticon anticon-eye"/>
				  </Button>
				</Tooltip>
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 9 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('ТЛЦ') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntLogisticsCenter())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterLogisticsCenter
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddStorageModal
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditStorage : onAddStorage }
	  />
	  <LogisticsCenterDetailsModal
		id={ viewItemId }
		show={ showViewModal }
		onHide={ () => setShowViewModal(false) }
	  />
	  { contextHolder }
	</>
  );
}
